import pointApi from '@/apis/liff/v2/point'

export default {
  namespaced: true,
  state: {
    availablePoints: '-',
    expiringavailablePointsDate: null,
    expiringSoonPoints: null,
    expiringSoonPointsDate: null,
    loading: false,
  },
  getters: {
    availablePoints({availablePoints}) {
      return availablePoints;
    },
    expiringavailablePointsDate({expiringavailablePointsDate}) {
      return expiringavailablePointsDate;
    },
    expiringSoonPoints({expiringSoonPoints}) {
      return expiringSoonPoints;
    },
    expiringSoonPointsDate({expiringSoonPointsDate}) {
      return expiringSoonPointsDate;
    },
    loading({loading}) {
      return loading;
    },
  },
  mutations: {
    SET_AVAILABLE_POINTS(state, point) {
      state.availablePoints = point;
    },
    SET_EXPIRING_AVAILABLE_POINTS_DATE(state, date) {
      state.expiringavailablePointsDate = date;
    },
    SET_EXPIRING_SOON_POINTS(state, point) {
      state.expiringSoonPoints = point;
    },
    SET_EXPIRING_SOON_POINTS_DATE(state, date) {
      state.expiringSoonPointsDate = date;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAvailablePoints({commit}, { eventCode }) {
      const info = await pointApi.getAvailablePoints(eventCode)
      commit('SET_AVAILABLE_POINTS', info.point)
      commit('SET_EXPIRING_AVAILABLE_POINTS_DATE', info.expired_at)
    },
    async fetchExpiringSoonPoints({commit}, { eventCode }) {
      const info = await pointApi.getExpiringSoonPoints(eventCode)
      commit('SET_EXPIRING_SOON_POINTS', info.point)
      commit('SET_EXPIRING_SOON_POINTS_DATE', info.expired_at)
    }
  },
};
